import React, { useState } from "react";
import styles from "./SummariesPage.module.css";
import dayjs from "dayjs";

import AddItemButton from "ManagementTeam/Shared/AddItemButton";
import YearFilterDropdown from "ManagementTeam/Shared/YearFilterDropdown";
import SummariesIcon from "../assets/Menu_Icon_Summaries.svg";
import DocumentItem from "ManagementTeam/Shared/DocumentItem";
import AddSummaryModal from "./AddSummaryModal";
import { Header } from "ManagementTeam/Shared/Header/Header";

import {
  useSummaries,
  useAddSummary,
  useEditSummary,
  useDeleteSummary,
} from "./useSummaries";
import { useEffect } from "react";
import Auth from "shared/@auth";
import { useIsFetching } from "react-query";
import { useLocation } from "react-router-dom";
import Loader from "shared/Loader";

export function SummariesPage() {
  const { hasPermission } = Auth.useContainer();
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [summaries, setSummaries] = useState([]);

  const defaultSummary = {
    name: "",
    files: [],
  };

  const currentYear = dayjs().format("YYYY");

  const yearArray = new Array(3);
  for (let i = 0, f = currentYear - 2; i < 3; i++, f++) {
    yearArray[i] = f.toString();
  }

  const [editingSummary, setEditingSummary] = useState(defaultSummary);
  const [selectedYear, setSelectedYear] = useState(currentYear);

  const {
    data,
    status,
    refetch: refetchSummaries,
  } = useSummaries(selectedYear);

  const addSummary = useAddSummary();
  const editSummary = useEditSummary();
  const deleteSummary = useDeleteSummary();

  const readOnly = !hasPermission("management-team.admins");

  useEffect(() => {
    if (status === "success") {
      setSummaries([...data]);
    }
  }, [data, selectedYear, status]);

  const handleSaving = (summary) => {
    addSummary(summary);
    setShowAddModal(false);
  };

  const handleEdit = (summary) => {
    setEditingSummary({ ...summary });
    setShowEditModal(true);
  };

  const handleSaveEdit = (summary) => {
    editSummary(summary);
    setShowEditModal(false);
  };

  const handleDelete = (summary) => {
    deleteSummary(summary);
    setShowEditModal(false);
  };

  const handleClose = () => {
    setEditingSummary(defaultSummary);
    setShowAddModal(false);
  };
  // Header refresh wiring
  const [isRefreshing, setIsRefreshing] = useState(false);
  const location = useLocation();
  const meetingType =
    location.pathname.split("/")[1] === "executive-committee" ? "ec" : "mt";
  const activeFetchCount = useIsFetching([meetingType, selectedYear]);

  const handleRefresh = async () => {
    try {
      setIsRefreshing(true);
      await refetchSummaries();
    } finally {
      setIsRefreshing(false);
    }
  };
  return (
    <div className={styles.summariesContainer}>
      <AddSummaryModal
        isOpen={showAddModal}
        onSave={handleSaving}
        onSaveDraft={handleSaving}
        onClose={() => handleClose()}
      />
      <AddSummaryModal
        isOpen={showEditModal}
        summary={editingSummary}
        onSave={handleSaveEdit}
        onSaveDraft={handleSaveEdit}
        onClose={() => {
          setEditingSummary(defaultSummary);
          setShowEditModal(false);
          refetchSummaries();
        }}
      />

      <div className={styles.header}>
        <Header
          title={"Summaries"}
          icon={SummariesIcon}
          onRefresh={handleRefresh}
          isLoading={
            isRefreshing || activeFetchCount > 0 || status === "loading"
          }
        />
      </div>
      <div
        style={{ visibility: !readOnly ? "visible" : "hidden" }}
        className={styles.buttonContainer}
      >
        <div className={styles.addItemButton}>
          <AddItemButton
            onClick={() => {
              setEditingSummary(defaultSummary);
              setShowAddModal(true);
            }}
          />
          <div className={styles.addItemButtonText}>ADD NEW DOCUMENT</div>
        </div>
      </div>
      <div className={styles.yearFilterDropdown}>
        <YearFilterDropdown
          currentYear={selectedYear}
          yearOptions={yearArray}
          onChangeYear={(value) => setSelectedYear(value)}
        />
      </div>
      <div className={styles.documentsScrollContainer}>
        <div className={styles.documentsContainer}>
          {status === "success" ? (
            <>
              {summaries.length > 0 ? (
                <>
                  {summaries
                    .sort((a, b) => {
                      if (
                        new Date(a?.date).getTime() >
                        new Date(b?.date).getTime()
                      )
                        return -1;
                      if (
                        new Date(a?.date).getTime() <
                        new Date(b?.date).getTime()
                      )
                        return 1;
                      return 0;
                    })
                    .map((summary, i) => (
                      <div key={i} className={styles.docItem}>
                        <DocumentItem
                          readOnly={readOnly}
                          title={summary.name}
                          description={""}
                          link={
                            summary?.files && summary?.files?.length > 0
                              ? summary?.files[0].src
                              : ""
                          }
                          type={"WWG"}
                          onEdit={() => handleEdit(summary)}
                          onDelete={() => handleDelete(summary)}
                          files={summary?.files}
                          separate={true}
                          reorganize={false}
                        />
                      </div>
                    ))}
                </>
              ) : (
                <div className={styles.loadMessage}>No summaries found</div>
              )}
            </>
          ) : status === "loading" ? (
            <div className={styles.loadMessage}>
              <Loader />
            </div>
          ) : (
            <div className={styles.loadMessage}>Error fetching data</div>
          )}
          {/* {summaries.length !== 0 && status === "success" && (
            <span className={styles.documentsDivider} />
          )} */}
        </div>
      </div>
    </div>
  );
}
